import { GiSplash } from "react-icons/gi";

export default function BerfIcon() {
  return (
    <GiSplash className="splash inline-block bottom-[3px] relative" />
  )
}